<template>
  <div>
    <van-nav-bar>
      <template #title>
        <div style="height: 40px;line-height: 40px">{{title}}</div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style lang="less">
</style>
